module.exports = __webpack_public_path__ + "static/img/emoji_2.41c33860.png";